module.exports = __webpack_public_path__ + "img/collection-diamondJewelry025Carat@2x.531e1da.jpg";